module.exports = __webpack_public_path__ + "static/media/CD-SING-TO-THE-LORD-4.e00ec981.jpg";